module.exports = __webpack_public_path__ + "static/media/IMG_7280-min.7a483969.jpg";